import { Store } from 'vuex';
import { Route, RouteConfig } from 'vue-router';
import { State } from './store';

import { Access, createRoutes as createAccessRoutes } from '../dndg/access';
import App from './home/app.vue';
import Signup from './signup/signup.vue';
import SurveyLanding from './signup/survey-landing.vue';
import RepubblicaLanding from './signup/repubblica-landing.vue';
import Register from './signup/register.vue';
import About from './about/about.vue';
import PrivacyPolicy from './privacy-policy/privacy-policy.vue';
import SurveyChooser from './surveys/survey-chooser.vue';
import Survey from './surveys/survey.vue';
import Results from './surveys/results.vue';
import PartitometroInfo from './surveys/partitometro-info.vue';
import PartitometroAffinita from './surveys/partitometro-affinita.vue';
import EuroPartitometroInfo from './surveys/europartitometro-info.vue';

import Page404 from './common/page404.vue';

// By default we export a function that returns the routes and
// let us use the injected store when needed.

const basePath = '/:lang/';

const homeRouteName = 'survey-chooser';

export function initRoutes(store: Store<State>): RouteConfig[]  {

    return [
        {
            path: basePath + 'access',
            component: Access,
            props: (route) => ({
                bannerSrc: '/_assets/resources/banner.jpg',
                bannerMobileSrc: '/_assets/resources/banner_mobile.jpg'
            }),
            children: createAccessRoutes(routeParams, homeRouteName)
        },
        {
            path: basePath,
            component: App,
            children: [
                {
                    path: 'signup',
                    name: 'signup',
                    component: Signup
                },
                {
                    path: 'register',
                    name: 'register',
                    component: Register
                },
                {
                    path: 'about',
                    name: 'about',
                    component: About
                },
                {
                    path: 'privacy-policy',
                    name: 'privacy-policy',
                    component: PrivacyPolicy
                },
                {
                    path: 'survey-chooser',
                    name: 'survey-chooser',
                    component: SurveyChooser
                },
                {
                    path: ':slug/play',
                    name: 'survey',
                    component: Survey
                },
                 {
                    path: ':slug/landing',
                    name: 'survey-landing',
                    component: SurveyLanding
                },
                {
                    path: ':slug/results',
                    name: 'results',
                    component: Results
                },
                {
                    path: ':slug/repubblica',
                    name: 'repubblica-landing',
                    component: RepubblicaLanding
                },
                {
                    path: 'partitometro/info',
                    name: 'partitometro-info',
                    component: PartitometroInfo
                },
                {
                    path: 'partitometro/affinita',
                    name: 'partitometro-affinita',
                    component: PartitometroAffinita
                },
                {
                    path: 'europartitometro/info',
                    name: 'europartitometro-info',
                    component: EuroPartitometroInfo
                },
                {
                    path: '*',
                    name: '404',
                    component: Page404
                }
            ]
        }
    ]
}


export function routeParams(route: Route, params?: any) {
    return {
        lang: route.params.lang,
        ...params
    };
}

export {
    homeRouteName
}



// WEBPACK FOOTER //
// ./src/app/routes.ts